import Master from 'components/helper/Master'
import React from 'react'

function LocationMaster() {
  return (
    <Master name={{name:"Location Master"}} getUrl={"/Admin/getalllocation"} deleteUrl={"/Admin/deletelocation"} updateurl={"/Admin/Updatelocation"}addurl={"/Admin/addlocation"} id={'LocationId'}/>
  )
}

export default LocationMaster;